import { Icon, IconProps } from "@chakra-ui/react";

export const EyeShutIcon = (props: IconProps) => (
  <Icon
    width="21px"
    height="12px"
    viewBox="0 0 21 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.76 5.22023L18.34 3.59023C18.72 3.09023 18.94 2.73023 18.97 2.67023C19.25 2.20023 19.09 1.58023 18.62 1.30023C18.15 1.02023 17.53 1.17023 17.25 1.65023C17.22 1.70023 14.36 6.40023 9.99999 6.40023C5.63999 6.40023 2.98999 1.90023 2.80999 1.59023C2.66999 1.28023 2.38 1.05023 2.01 1.00023C1.45 0.940229 0.969985 1.33023 0.899985 1.88023C0.849985 2.28023 1.25998 2.95023 1.70998 3.56023L0.260001 5.22023C-0.0999988 5.64023 -0.0600232 6.27023 0.359977 6.63023C0.549977 6.80023 0.779981 6.88023 1.01998 6.88023C1.29998 6.88023 1.57998 6.76023 1.76998 6.54023L3.02999 5.10023C3.54999 5.63023 4.14999 6.17023 4.83999 6.66023L3.6 8.93023C3.34 9.41023 3.50999 10.0202 3.99999 10.2902C4.14999 10.3702 4.32 10.4102 4.48 10.4102C4.83 10.4102 5.17998 10.2202 5.35998 9.89023L6.57998 7.66023C7.31998 7.99023 8.13998 8.22023 9.01998 8.33023V10.3802C9.01998 10.9302 9.46998 11.3802 10.02 11.3802C10.57 11.3802 11.02 10.9302 11.02 10.3802V8.34023C11.9 8.23023 12.71 7.98023 13.45 7.65023L14.68 9.90023C14.86 10.2302 15.2 10.4202 15.56 10.4202C15.72 10.4202 15.89 10.3802 16.04 10.3002C16.52 10.0402 16.7 9.43023 16.44 8.94023L15.2 6.67023C15.91 6.18023 16.52 5.64023 17.04 5.11023L18.27 6.52023C18.47 6.75023 18.74 6.86023 19.02 6.86023C19.25 6.86023 19.49 6.78023 19.68 6.61023C20.1 6.25023 20.14 5.62023 19.78 5.20023L19.76 5.22023Z"
      fill="black"
    />
  </Icon>
);

export const EyeOpenIcon = (props: IconProps) => (
  <Icon
    width="22px"
    height="18px"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.03555 9.3224C0.966466 9.11513 0.9664 8.89073 1.03536 8.68343C2.42372 4.50972 6.36079 1.5 11.0008 1.5C15.6387 1.5 19.5742 4.50692 20.9643 8.6776C21.0334 8.88487 21.0335 9.10927 20.9645 9.31658C19.5761 13.4903 15.6391 16.5 10.9991 16.5C6.36119 16.5 2.42564 13.4931 1.03555 9.3224Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 9C14 10.6569 12.6569 12 11 12C9.34314 12 8 10.6569 8 9C8 7.34315 9.34314 6 11 6C12.6569 6 14 7.34315 14 9Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const EyeSlashIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L3.53033 2.46967Z"
      fill="#0F172A"
    />
    <path
      d="M22.6759 12.5533C22.1319 14.1887 21.2226 15.6575 20.0447 16.8627L16.9462 13.7642C17.1429 13.2129 17.25 12.6189 17.25 12C17.25 9.1005 14.8995 6.75 12 6.75C11.3811 6.75 10.7871 6.8571 10.2358 7.05379L7.75898 4.577C9.06783 4.04381 10.4998 3.75 12.0005 3.75C16.9708 3.75 21.1864 6.97271 22.6755 11.4405C22.7959 11.8015 22.796 12.1922 22.6759 12.5533Z"
      fill="#0F172A"
    />
    <path
      d="M15.75 12C15.75 12.1802 15.7373 12.3574 15.7127 12.5308L11.4692 8.28727C11.6426 8.2627 11.8198 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12Z"
      fill="#0F172A"
    />
    <path
      d="M12.5308 15.7127L8.28727 11.4692C8.2627 11.6426 8.25 11.8198 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C12.1802 15.75 12.3574 15.7373 12.5308 15.7127Z"
      fill="#0F172A"
    />
    <path
      d="M6.75 12C6.75 11.3811 6.8571 10.7871 7.05379 10.2358L3.95492 7.1369C2.77687 8.34222 1.86747 9.81114 1.32341 11.4467C1.20328 11.8078 1.2034 12.1985 1.32374 12.5595C2.81284 17.0273 7.02847 20.25 11.9988 20.25C13.4997 20.25 14.9318 19.9561 16.2408 19.4228L13.7642 16.9462C13.2129 17.1429 12.6189 17.25 12 17.25C9.1005 17.25 6.75 14.8995 6.75 12Z"
      fill="#0F172A"
    />
  </Icon>
);

export const CheckedIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="12" fill="#00C707" />
    <path
      d="M7.01099 12.2945L10.1409 15.4241L16.9889 8.57593"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CheckedDarkIcon = (props: IconProps) => (
  <Icon
    width="25px"
    height="24px"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" width="24" height="24" rx="12" fill="#1A1C1F" />
    <path
      d="M7.51123 12.2943L10.6411 15.4239L17.4892 8.57568"
      stroke="#00C707"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const UncheckedIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="12" fill="#F9FAFA" />
    <path
      d="M7.01099 12.2945L10.1409 15.4241L16.9889 8.57593"
      stroke="#EBEDEF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const BuildingStoreFrontIcon = (props?: IconProps) => (
  <Icon
    width="44px"
    height="44px"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.57614 4.125C8.66446 4.125 7.79012 4.48716 7.14546 5.13182L4.76364 7.51364C2.07879 10.1985 2.07879 14.5515 4.76364 17.2364C7.21509 19.6878 11.0573 19.9009 13.7505 17.8757C14.8989 18.7378 16.3276 19.25 17.875 19.25C19.4226 19.25 20.8515 18.7377 22 17.8753C23.1485 18.7377 24.5774 19.25 26.125 19.25C27.6724 19.25 29.1011 18.7378 30.2495 17.8757C32.9427 19.9009 36.7849 19.6878 39.2364 17.2364C41.9212 14.5515 41.9212 10.1985 39.2364 7.51364L36.8545 5.13183C36.2099 4.48717 35.3355 4.12501 34.4239 4.12501L9.57614 4.125Z"
      fill="#0F172A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 37.125V21.0744C8.10372 22.309 11.1465 22.3082 13.7508 21.073C15.0015 21.6668 16.4012 22 17.875 22C19.3491 22 20.7491 21.6667 22 21.0726C23.2509 21.6667 24.6509 22 26.125 22C27.5988 22 28.9985 21.6668 30.2492 21.073C32.8535 22.3082 35.8963 22.309 38.5 21.0744V37.125H39.875C40.6344 37.125 41.25 37.7406 41.25 38.5C41.25 39.2594 40.6344 39.875 39.875 39.875H4.125C3.36561 39.875 2.75 39.2594 2.75 38.5C2.75 37.7406 3.36561 37.125 4.125 37.125H5.5ZM11 26.125C11 25.3656 11.6156 24.75 12.375 24.75H17.875C18.6344 24.75 19.25 25.3656 19.25 26.125V31.625C19.25 32.3844 18.6344 33 17.875 33H12.375C11.6156 33 11 32.3844 11 31.625V26.125ZM26.125 24.75C25.3656 24.75 24.75 25.3656 24.75 26.125V35.75C24.75 36.5094 25.3656 37.125 26.125 37.125H31.625C32.3844 37.125 33 36.5094 33 35.75V26.125C33 25.3656 32.3844 24.75 31.625 24.75H26.125Z"
      fill="#0F172A"
    />
  </Icon>
);

export const ChatBubbleIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.91307 2.65823C6.9877 2.38888 9.10296 2.25 11.2503 2.25C13.3974 2.25 15.5124 2.38885 17.5869 2.65815C19.5091 2.90769 20.8783 4.51937 20.9923 6.38495C20.6665 6.27614 20.3212 6.20396 19.96 6.17399C18.5715 6.05874 17.1673 6 15.75 6C14.3326 6 12.9285 6.05874 11.54 6.17398C9.1817 6.36971 7.5 8.36467 7.5 10.6082V14.8937C7.5 16.5844 8.45468 18.1326 9.9328 18.8779L7.28033 21.5303C7.06583 21.7448 6.74324 21.809 6.46299 21.6929C6.18273 21.5768 6 21.3033 6 21V16.9705C5.63649 16.9316 5.27417 16.8887 4.91308 16.8418C2.90466 16.581 1.5 14.8333 1.5 12.8626V6.63738C1.5 4.66672 2.90466 2.91899 4.91307 2.65823Z"
      fill="white"
    />
    <path
      d="M15.75 7.5C14.3741 7.5 13.0114 7.55702 11.6641 7.66884C10.1248 7.7966 9 9.10282 9 10.6082V14.8937C9 16.4014 10.128 17.7083 11.6692 17.8341C12.9131 17.9357 14.17 17.9912 15.4384 17.999L18.2197 20.7803C18.4342 20.9948 18.7568 21.059 19.037 20.9429C19.3173 20.8268 19.5 20.5533 19.5 20.25V17.8601C19.6103 17.8518 19.7206 17.8432 19.8307 17.8342C21.372 17.7085 22.5 16.4015 22.5 14.8938V10.6082C22.5 9.10283 21.3752 7.79661 19.836 7.66885C18.4886 7.55702 17.1259 7.5 15.75 7.5Z"
      fill="white"
    />
  </Icon>
);

export const ArrowUpOnSquareIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 6.875H6.25C5.21447 6.875 4.375 7.71447 4.375 8.75V16.25C4.375 17.2855 5.21447 18.125 6.25 18.125H13.75C14.7855 18.125 15.625 17.2855 15.625 16.25V8.75C15.625 7.71447 14.7855 6.875 13.75 6.875H12.5M12.5 4.375L10 1.875M10 1.875L7.5 4.375M10 1.875L10 12.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowUpOnSquareGreenIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.55806 1.43306C9.80214 1.18898 10.1979 1.18898 10.4419 1.43306L12.9419 3.93306C13.186 4.17714 13.186 4.57286 12.9419 4.81694C12.6979 5.06102 12.3021 5.06102 12.0581 4.81694L10.625 3.38388L10.625 6.25H9.375V3.38388L7.94194 4.81694C7.69786 5.06102 7.30214 5.06102 7.05806 4.81694C6.81398 4.57286 6.81398 4.17713 7.05806 3.93306L9.55806 1.43306Z"
      fill="#14CC52"
    />
    <path
      d="M9.375 6.25L9.375 12.5C9.375 12.8452 9.65482 13.125 10 13.125C10.3452 13.125 10.625 12.8452 10.625 12.5V6.25H13.75C15.1307 6.25 16.25 7.36929 16.25 8.75V16.25C16.25 17.6307 15.1307 18.75 13.75 18.75H6.25C4.86929 18.75 3.75 17.6307 3.75 16.25V8.75C3.75 7.36929 4.86929 6.25 6.25 6.25H9.375Z"
      fill="#14CC52"
    />
  </Icon>
);

export const BankNotesIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.875 15.625C6.431 15.625 10.8447 16.2344 15.039 17.376C15.6448 17.5409 16.25 17.0905 16.25 16.4626V15.625M3.125 3.75V4.375C3.125 4.72018 2.84518 5 2.5 5H1.875M1.875 5V4.6875C1.875 4.16973 2.29473 3.75 2.8125 3.75H16.875M1.875 5V12.5M16.875 3.75V4.375C16.875 4.72018 17.1548 5 17.5 5H18.125M16.875 3.75H17.1875C17.7053 3.75 18.125 4.16973 18.125 4.6875V12.8125C18.125 13.3303 17.7053 13.75 17.1875 13.75H16.875M18.125 12.5H17.5C17.1548 12.5 16.875 12.7798 16.875 13.125V13.75M16.875 13.75H3.125M3.125 13.75H2.8125C2.29473 13.75 1.875 13.3303 1.875 12.8125V12.5M3.125 13.75V13.125C3.125 12.7798 2.84518 12.5 2.5 12.5H1.875M12.5 8.75C12.5 10.1307 11.3807 11.25 10 11.25C8.61929 11.25 7.5 10.1307 7.5 8.75C7.5 7.36929 8.61929 6.25 10 6.25C11.3807 6.25 12.5 7.36929 12.5 8.75ZM15 8.75H15.0062V8.75625H15V8.75ZM5 8.75H5.00625V8.75625H5V8.75Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CalculatorIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.125 13.125V15M6.875 9.375H6.88125V9.38125H6.875V9.375ZM6.875 11.25H6.88125V11.2563H6.875V11.25ZM6.875 13.125H6.88125V13.1313H6.875V13.125ZM6.875 15H6.88125V15.0063H6.875V15ZM8.9563 9.375H8.96255V9.38125H8.9563V9.375ZM8.9563 11.25H8.96255V11.2563H8.9563V11.25ZM8.9563 13.125H8.96255V13.1313H8.9563V13.125ZM8.9563 15H8.96255V15.0063H8.9563V15ZM11.0437 9.375H11.05V9.38125H11.0437V9.375ZM11.0437 11.25H11.05V11.2563H11.0437V11.25ZM11.0437 13.125H11.05V13.1313H11.0437V13.125ZM11.0437 15H11.05V15.0063H11.0437V15ZM13.125 9.375H13.1313V9.38125H13.125V9.375ZM13.125 11.25H13.1313V11.2563H13.125V11.25ZM6.875 5H13.125V6.875H6.875V5ZM10 1.875C8.42333 1.875 6.86797 1.96622 5.3389 2.14367C4.42173 2.25011 3.75 3.04083 3.75 3.96416V16.25C3.75 17.2855 4.58947 18.125 5.625 18.125H14.375C15.4105 18.125 16.25 17.2855 16.25 16.25V3.96416C16.25 3.04083 15.5783 2.25011 14.6611 2.14367C13.132 1.96622 11.5767 1.875 10 1.875Z"
      stroke={String(props.stroke || "#1A1C1F")}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChartPieIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.75 5C5.29822 5 2.5 7.79822 2.5 11.25C2.5 14.7018 5.29822 17.5 8.75 17.5C12.2018 17.5 15 14.7018 15 11.25H8.75V5Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 8.75H17.5C17.5 5.29822 14.7018 2.5 11.25 2.5V8.75Z"
      stroke={String(props.stroke || "#1A1C1F")}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CogToothIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99473 3.28338C8.07007 2.83132 8.46119 2.5 8.91947 2.5H11.0811C11.5394 2.5 11.9305 2.83132 12.0059 3.28338L12.1838 4.35092C12.2357 4.66262 12.444 4.92226 12.7205 5.0753C12.7823 5.10952 12.8434 5.14486 12.9038 5.18131C13.1746 5.34487 13.5041 5.39572 13.8004 5.28471L14.8144 4.90481C15.2436 4.74404 15.7261 4.91709 15.9552 5.31398L17.0361 7.18601C17.2652 7.5829 17.1738 8.08728 16.82 8.37855L15.9831 9.06756C15.7393 9.26823 15.6185 9.5781 15.6243 9.89377C15.625 9.9291 15.6253 9.96451 15.6253 10C15.6253 10.0355 15.625 10.0709 15.6243 10.1062C15.6185 10.4219 15.7393 10.7318 15.9831 10.9324L16.82 11.6214C17.1738 11.9127 17.2652 12.4171 17.0361 12.814L15.9552 14.686C15.7261 15.0829 15.2436 15.256 14.8144 15.0952L13.8004 14.7153C13.5041 14.6043 13.1747 14.6551 12.9038 14.8187C12.8434 14.8551 12.7823 14.8905 12.7205 14.9247C12.444 15.0777 12.2357 15.3374 12.1838 15.6491L12.0059 16.7166C11.9305 17.1687 11.5394 17.5 11.0811 17.5H8.91947C8.46119 17.5 8.07007 17.1687 7.99473 16.7166L7.8168 15.6491C7.76485 15.3374 7.55654 15.0777 7.28007 14.9247C7.21826 14.8905 7.15716 14.8551 7.0968 14.8187C6.82594 14.6551 6.49649 14.6043 6.20019 14.7153L5.18613 15.0952C4.75698 15.256 4.27448 15.0829 4.04534 14.686L2.96452 12.814C2.73538 12.4171 2.82676 11.9127 3.18057 11.6215L4.01753 10.9324C4.26129 10.7318 4.38212 10.4219 4.37627 10.1062C4.37562 10.0709 4.37529 10.0355 4.37529 10C4.37529 9.96452 4.37562 9.92911 4.37627 9.89379C4.38212 9.57811 4.26129 9.26824 4.01753 9.06758L3.18057 8.37856C2.82675 8.08729 2.73538 7.58291 2.96452 7.18602L4.04534 5.31399C4.27448 4.9171 4.75698 4.74405 5.18613 4.90483L6.20018 5.28472C6.49648 5.39573 6.82593 5.34487 7.09679 5.18132C7.15715 5.14487 7.21825 5.10952 7.28007 5.0753C7.55654 4.92226 7.76485 4.66262 7.8168 4.35092L7.99473 3.28338Z"
      stroke={String(props.stroke || "#1A1C1F")}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5001 9.99993C12.5001 11.3806 11.3808 12.4999 10.0001 12.4999C8.61939 12.4999 7.5001 11.3806 7.5001 9.99993C7.5001 8.61922 8.61939 7.49993 10.0001 7.49993C11.3808 7.49993 12.5001 8.61922 12.5001 9.99993Z"
      stroke={String(props.stroke || "#1A1C1F")}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CreditCardIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.875 6.875H18.125M1.875 7.5H18.125M4.375 11.875H9.375M4.375 13.75H6.875M3.75 16.25H16.25C17.2855 16.25 18.125 15.4105 18.125 14.375V5.625C18.125 4.58947 17.2855 3.75 16.25 3.75H3.75C2.71447 3.75 1.875 4.58947 1.875 5.625V14.375C1.875 15.4105 2.71447 16.25 3.75 16.25Z"
      stroke={String(props.stroke || "#1A1C1F")}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const DocumentChartBarIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.25 11.875V9.6875C16.25 8.1342 14.9908 6.875 13.4375 6.875H12.1875C11.6697 6.875 11.25 6.45527 11.25 5.9375V4.6875C11.25 3.1342 9.9908 1.875 8.4375 1.875H6.875M7.5 13.75V14.375M10 11.875V14.375M12.5 10V14.375M8.75 1.875H4.6875C4.16973 1.875 3.75 2.29473 3.75 2.8125V17.1875C3.75 17.7053 4.16973 18.125 4.6875 18.125H15.3125C15.8303 18.125 16.25 17.7053 16.25 17.1875V9.375C16.25 5.23286 12.8921 1.875 8.75 1.875Z"
      stroke={String(props.stroke || "#1A1C1F")}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const DocumentTextIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.5 14.25V11.625C19.5 9.76104 17.989 8.25 16.125 8.25H14.625C14.0037 8.25 13.5 7.74632 13.5 7.125V5.625C13.5 3.76104 11.989 2.25 10.125 2.25H8.25M8.25 15H15.75M8.25 18H12M10.5 2.25H5.625C5.00368 2.25 4.5 2.75368 4.5 3.375V20.625C4.5 21.2463 5.00368 21.75 5.625 21.75H18.375C18.9963 21.75 19.5 21.2463 19.5 20.625V11.25C19.5 6.27944 15.4706 2.25 10.5 2.25Z"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const FlagIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 2.5V3.75M2.5 17.5V12.5M2.5 12.5L4.80841 11.9229C6.54529 11.4887 8.3802 11.6901 9.98153 12.4908L10.0713 12.5356C11.6406 13.3203 13.4353 13.5299 15.1432 13.1281L17.7384 12.5174C17.5809 11.075 17.5 9.60942 17.5 8.125C17.5 6.65285 17.5795 5.19928 17.7345 3.76835L15.1432 4.37807C13.4353 4.77993 11.6406 4.5703 10.0713 3.78565L9.98153 3.74076C8.3802 2.9401 6.54529 2.73868 4.80841 3.1729L2.5 3.75M2.5 12.5V3.75"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const GiftIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 9.375V16.25C17.5 16.9404 16.9404 17.5 16.25 17.5H4.375C3.68464 17.5 3.125 16.9404 3.125 16.25V9.375M10 4.0625C10 2.85438 9.02062 1.875 7.8125 1.875C6.60438 1.875 5.625 2.85438 5.625 4.0625C5.625 5.27062 6.60438 6.25 7.8125 6.25C8.42459 6.25 10 6.25 10 6.25M10 4.0625C10 4.65853 10 6.25 10 6.25M10 4.0625C10 2.85438 10.9794 1.875 12.1875 1.875C13.3956 1.875 14.375 2.85438 14.375 4.0625C14.375 5.27062 13.3956 6.25 12.1875 6.25C11.5754 6.25 10 6.25 10 6.25M10 6.25V17.5M2.8125 9.375H17.8125C18.3303 9.375 18.75 8.95527 18.75 8.4375V7.1875C18.75 6.66973 18.3303 6.25 17.8125 6.25H2.8125C2.29473 6.25 1.875 6.66973 1.875 7.1875V8.4375C1.875 8.95527 2.29473 9.375 2.8125 9.375Z"
      stroke={String(props.stroke || "#1A1C1F")}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const GlobeAltIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 17.5C13.4938 17.5 16.4296 15.111 17.2631 11.8775M10 17.5C6.50619 17.5 3.57035 15.111 2.73692 11.8775M10 17.5C12.0711 17.5 13.75 14.1421 13.75 10C13.75 5.85786 12.0711 2.5 10 2.5M10 17.5C7.92893 17.5 6.25 14.1421 6.25 10C6.25 5.85786 7.92893 2.5 10 2.5M10 2.5C12.8043 2.5 15.2492 4.03912 16.5359 6.31871M10 2.5C7.19567 2.5 4.75083 4.03912 3.4641 6.31871M16.5359 6.31871C14.7831 7.83366 12.4986 8.75 10 8.75C7.50143 8.75 5.21689 7.83366 3.4641 6.31871M16.5359 6.31871C17.1497 7.40619 17.5 8.66219 17.5 10C17.5 10.6483 17.4177 11.2774 17.2631 11.8775M17.2631 11.8775C15.1111 13.0706 12.6349 13.75 10 13.75C7.36509 13.75 4.88885 13.0706 2.73692 11.8775M2.73692 11.8775C2.58226 11.2774 2.5 10.6483 2.5 10C2.5 8.66219 2.85027 7.40619 3.4641 6.31871"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const LinkIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5847 3.41529C15.3643 2.1949 13.3857 2.1949 12.1653 3.41529L8.41529 7.16529C7.1949 8.38568 7.1949 10.3643 8.41529 11.5847C8.67435 11.8438 8.96648 12.0471 9.27752 12.1957C9.58899 12.3445 9.72086 12.7176 9.57207 13.0291C9.42328 13.3405 9.05018 13.4724 8.73871 13.3236C8.30141 13.1147 7.89219 12.8294 7.53141 12.4686C5.82286 10.76 5.82286 7.98995 7.53141 6.28141L11.2814 2.53141C12.99 0.822864 15.76 0.822864 17.4686 2.53141C19.1771 4.23995 19.1771 7.01005 17.4686 8.71859L16.0044 10.1827C15.7604 10.4268 15.3646 10.4268 15.1206 10.1827C14.8765 9.93866 14.8765 9.54293 15.1206 9.29885L16.5847 7.83471C17.8051 6.61432 17.8051 4.63568 16.5847 3.41529ZM10.4279 6.97094C10.5767 6.65948 10.9498 6.52761 11.2613 6.67639C11.6986 6.8853 12.1078 7.17062 12.4686 7.53141C14.1771 9.23995 14.1771 12.01 12.4686 13.7186L8.71859 17.4686C7.01005 19.1771 4.23995 19.1771 2.53141 17.4686C0.822864 15.76 0.822864 12.99 2.53141 11.2814L3.99555 9.81727C4.23963 9.57319 4.63536 9.57319 4.87943 9.81727C5.12351 10.0613 5.12351 10.4571 4.87943 10.7011L3.41529 12.1653C2.1949 13.3857 2.1949 15.3643 3.41529 16.5847C4.63568 17.8051 6.61432 17.8051 7.83471 16.5847L11.5847 12.8347C12.8051 11.6143 12.8051 9.63568 11.5847 8.41529C11.3257 8.15623 11.0335 7.95289 10.7225 7.80431C10.411 7.65552 10.2791 7.28241 10.4279 6.97094Z"
    />
  </Icon>
);

export const ShieldCheckIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 10.6248L9.375 12.4998L12.5 8.12483M10 2.26172C8.20792 3.9589 5.78802 4.99984 3.125 4.99984C3.08269 4.99984 3.04043 4.99958 2.99825 4.99906C2.67491 5.98248 2.5 7.03325 2.5 8.12488C2.5 12.7845 5.68693 16.6997 10 17.8098C14.3131 16.6997 17.5 12.7845 17.5 8.12488C17.5 7.03325 17.3251 5.98248 17.0018 4.99906C16.9596 4.99958 16.9173 4.99984 16.875 4.99984C14.212 4.99984 11.7921 3.9589 10 2.26172Z"
      stroke={String(props.stroke || "#1A1C1F")}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SquaresPlusIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.25 14.0625H14.0625M14.0625 14.0625H16.875M14.0625 14.0625V11.25M14.0625 14.0625V16.875M5 8.75H6.875C7.91053 8.75 8.75 7.91053 8.75 6.875V5C8.75 3.96447 7.91053 3.125 6.875 3.125H5C3.96447 3.125 3.125 3.96447 3.125 5V6.875C3.125 7.91053 3.96447 8.75 5 8.75ZM5 16.875H6.875C7.91053 16.875 8.75 16.0355 8.75 15V13.125C8.75 12.0895 7.91053 11.25 6.875 11.25H5C3.96447 11.25 3.125 12.0895 3.125 13.125V15C3.125 16.0355 3.96447 16.875 5 16.875ZM13.125 8.75H15C16.0355 8.75 16.875 7.91053 16.875 6.875V5C16.875 3.96447 16.0355 3.125 15 3.125H13.125C12.0895 3.125 11.25 3.96447 11.25 5V6.875C11.25 7.91053 12.0895 8.75 13.125 8.75Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const MobilePhoneIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.75 1.25H6.875C5.83947 1.25 5 2.08947 5 3.125V16.875C5 17.9105 5.83947 18.75 6.875 18.75H13.125C14.1605 18.75 15 17.9105 15 16.875V3.125C15 2.08947 14.1605 1.25 13.125 1.25H11.25M8.75 1.25V2.5H11.25V1.25M8.75 1.25H11.25M8.75 16.875H11.25"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const TicketIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.75 5V5.625M13.75 8.125V8.75M13.75 11.25V11.875M13.75 14.375V15M6.25 10.625H10.625M6.25 12.5H8.75M2.8125 4.375C2.29473 4.375 1.875 4.79473 1.875 5.3125V7.83446C2.62225 8.26672 3.125 9.07465 3.125 10C3.125 10.9254 2.62225 11.7333 1.875 12.1655V14.6875C1.875 15.2053 2.29473 15.625 2.8125 15.625H17.1875C17.7053 15.625 18.125 15.2053 18.125 14.6875V12.1655C17.3777 11.7333 16.875 10.9254 16.875 10C16.875 9.07465 17.3777 8.26672 18.125 7.83446V5.3125C18.125 4.79473 17.7053 4.375 17.1875 4.375H2.8125Z"
      stroke="#1A1C1F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const BellIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25001 8.9998C5.25012 5.27197 8.27215 2.25 12 2.25C15.7279 2.25 18.75 5.27208 18.75 9L18.7498 9.04919V9.75C18.7498 11.8731 19.5508 13.8074 20.8684 15.2699C21.0349 15.4547 21.0989 15.71 21.0393 15.9516C20.9797 16.1931 20.8042 16.3893 20.5709 16.4755C19.0269 17.0455 17.4105 17.4659 15.7396 17.7192C15.7465 17.812 15.75 17.9056 15.75 18C15.75 20.0711 14.0711 21.75 12 21.75C9.92894 21.75 8.25001 20.0711 8.25001 18C8.25001 17.9056 8.25351 17.812 8.2604 17.7192C6.58934 17.4659 4.97287 17.0455 3.42875 16.4755C3.19539 16.3893 3.01992 16.1931 2.96033 15.9516C2.90073 15.71 2.96476 15.4547 3.13126 15.2699C4.44879 13.8074 5.24981 11.8731 5.24981 9.75L5.25001 8.9998ZM9.75221 17.8993C9.75075 17.9326 9.75001 17.9662 9.75001 18C9.75001 19.2426 10.7574 20.25 12 20.25C13.2427 20.25 14.25 19.2426 14.25 18C14.25 17.9662 14.2493 17.9326 14.2478 17.8992C13.5072 17.9659 12.7574 18 11.9998 18C11.2424 18 10.4927 17.966 9.75221 17.8993Z"
      fill="#0F172A"
    />
  </Icon>
);

export const BarsIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.75C3 6.33579 3.33579 6 3.75 6H20.25C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75ZM3 12C3 11.5858 3.33579 11.25 3.75 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H3.75C3.33579 12.75 3 12.4142 3 12ZM3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25C21 17.6642 20.6642 18 20.25 18H3.75C3.33579 18 3 17.6642 3 17.25Z"
      fill="#0F172A"
    />
  </Icon>
);

export const ChevronDownIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.23017 7.20938C5.52875 6.92228 6.00353 6.93159 6.29063 7.23017L10 11.1679L13.7094 7.23017C13.9965 6.93159 14.4713 6.92228 14.7698 7.20938C15.0684 7.49647 15.0777 7.97125 14.7906 8.26983L10.5406 12.7698C10.3992 12.9169 10.204 13 10 13C9.79599 13 9.60078 12.9169 9.45938 12.7698L5.20938 8.26983C4.92228 7.97125 4.93159 7.49647 5.23017 7.20938Z"
      fill="#0F172A"
    />
  </Icon>
);

export const ChevronRightIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.20938 14.7698C6.92228 14.4713 6.93159 13.9965 7.23017 13.7094L11.1679 10L7.23017 6.29062C6.93159 6.00353 6.92228 5.52875 7.20938 5.23017C7.49647 4.93159 7.97125 4.92228 8.26983 5.20937L12.7698 9.45937C12.9169 9.60078 13 9.79599 13 10C13 10.204 12.9169 10.3992 12.7698 10.5406L8.26983 14.7906C7.97125 15.0777 7.49647 15.0684 7.20938 14.7698Z"
      fill="#009F06"
    />
  </Icon>
);

export const BusinessInformationIcon = (props: IconProps) => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="64" height="64" rx="32" fill="#1A1C1F" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 23C26 20.7909 27.7909 19 30 19H34C36.2091 19 38 20.7909 38 23V23.2733C39.2433 23.3871 40.4765 23.536 41.6987 23.7188C43.6375 24.0089 45 25.6955 45 27.6076V31.6519C45 33.2667 44.0218 34.7883 42.4183 35.3214C39.1421 36.4107 35.6389 37 32 37C28.3612 37 24.8579 36.4106 21.5817 35.3214C19.9782 34.7883 19 33.2667 19 31.6518V27.6076C19 25.6955 20.3625 24.0089 22.3013 23.7188C23.5235 23.536 24.7567 23.3871 26 23.2733V23ZM36 23V23.1211C34.6769 23.0408 33.3431 23 32 23C30.6569 23 29.3231 23.0408 28 23.1211V23C28 21.8954 28.8954 21 30 21H34C35.1046 21 36 21.8954 36 23ZM32 34C32.5523 34 33 33.5523 33 33C33 32.4477 32.5523 32 32 32C31.4477 32 31 32.4477 31 33C31 33.5523 31.4477 34 32 34Z"
      fill="white"
    />
    <path
      d="M20 40.5333V36.8052C20.2974 36.9683 20.6146 37.1075 20.9507 37.2193C24.4278 38.3753 28.144 39 32 39C35.856 39 39.5722 38.3753 43.0493 37.2193C43.3854 37.1076 43.7026 36.9684 44 36.8053V40.5333C44 42.4692 42.6037 44.17 40.6358 44.4313C37.81 44.8064 34.9274 45 32 45C29.0726 45 26.19 44.8064 23.3642 44.4313C21.3963 44.17 20 42.4692 20 40.5333Z"
      fill="white"
    />
  </Icon>
);

export const DocumentVerificationIcon = (props: IconProps) => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="64" height="64" rx="32" fill="#E6E8E8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.0024 24H30.9969L31 24H35.5065C37.9887 24.0036 39.9999 26.0169 39.9999 28.5V41C42.209 41 43.9999 39.2091 43.9999 37V24.1443C43.9999 22.1371 42.5002 20.3955 40.4478 20.2251C40.1494 20.2004 39.8505 20.1776 39.551 20.1569C38.8844 18.8753 37.5444 18 36 18H34C32.4556 18 31.1156 18.8753 30.449 20.1569C30.1494 20.1776 29.8504 20.2003 29.5519 20.2251C27.5489 20.3914 26.0723 22.0543 26.0024 24ZM34 20C32.8954 20 32 20.8954 32 22H38C38 20.8954 37.1046 20 36 20H34Z"
      fill="#0F172A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 28.5C20 27.1193 21.1193 26 22.5 26H35.5C36.8807 26 38 27.1193 38 28.5V43.5C38 44.8807 36.8807 46 35.5 46H22.5C21.1193 46 20 44.8807 20 43.5V28.5ZM24 32C24 31.4477 24.4477 31 25 31H25.01C25.5623 31 26.01 31.4477 26.01 32V32.01C26.01 32.5623 25.5623 33.01 25.01 33.01H25C24.4477 33.01 24 32.5623 24 32.01V32ZM27 32C27 31.4477 27.4477 31 28 31H33C33.5523 31 34 31.4477 34 32C34 32.5523 33.5523 33 33 33H28C27.4477 33 27 32.5523 27 32ZM24 36C24 35.4477 24.4477 35 25 35H25.01C25.5623 35 26.01 35.4477 26.01 36V36.01C26.01 36.5623 25.5623 37.01 25.01 37.01H25C24.4477 37.01 24 36.5623 24 36.01V36ZM27 36C27 35.4477 27.4477 35 28 35H33C33.5523 35 34 35.4477 34 36C34 36.5523 33.5523 37 33 37H28C27.4477 37 27 36.5523 27 36ZM24 40C24 39.4477 24.4477 39 25 39H25.01C25.5623 39 26.01 39.4477 26.01 40V40.01C26.01 40.5623 25.5623 41.01 25.01 41.01H25C24.4477 41.01 24 40.5623 24 40.01V40ZM27 40C27 39.4477 27.4477 39 28 39H33C33.5523 39 34 39.4477 34 40C34 40.5523 33.5523 41 33 41H28C27.4477 41 27 40.5523 27 40Z"
      fill="#0F172A"
    />
  </Icon>
);

export const OwnerInformationIcon = (props: IconProps) => (
  <Icon
    width="64px"
    height="64px"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="64" height="64" rx="32" fill="#E6E8E8" />
    <path
      d="M27.1998 28.8C29.8508 28.8 31.9998 26.6509 31.9998 24C31.9998 21.349 29.8508 19.2 27.1998 19.2C24.5488 19.2 22.3998 21.349 22.3998 24C22.3998 26.6509 24.5488 28.8 27.1998 28.8Z"
      fill="#0F172A"
    />
    <path
      d="M39.1998 30.4C41.4089 30.4 43.1998 28.6091 43.1998 26.4C43.1998 24.1908 41.4089 22.4 39.1998 22.4C36.9907 22.4 35.1998 24.1908 35.1998 26.4C35.1998 28.6091 36.9907 30.4 39.1998 30.4Z"
      fill="#0F172A"
    />
    <path
      d="M18.5843 42.2847C17.9486 41.8777 17.5804 41.1536 17.6735 40.4046C18.2625 35.6672 22.3029 32 27.1996 32C32.0964 32 36.1368 35.6662 36.7258 40.4034C36.8189 41.1524 36.4507 41.8765 35.8151 42.2836C33.3282 43.876 30.3717 44.7999 27.1996 44.7999C24.0276 44.7999 21.0711 43.8769 18.5843 42.2847Z"
      fill="#0F172A"
    />
    <path
      d="M39.1999 41.5999C39.1434 41.5999 39.087 41.5996 39.0307 41.5988C39.1408 41.1239 39.1713 40.6216 39.1074 40.1073C38.8267 37.8499 37.92 35.7872 36.5662 34.0986C37.3831 33.7767 38.2731 33.6 39.2043 33.6C42.3079 33.6 44.9528 35.5637 45.9645 38.3164C46.1819 38.908 45.927 39.5585 45.3872 39.8839C43.5805 40.9733 41.4634 41.5999 39.1999 41.5999Z"
      fill="#0F172A"
    />
  </Icon>
);

export const XFilledIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="32" height="32" rx="16" fill="#F9FAFA" />
    <path
      d="M22.8574 9.14282L9.14307 22.8571M9.14307 9.14282L22.8574 22.8571"
      stroke="#C9CFD4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowLeftIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="32" height="32" rx="16" fill="#F0FFF0" />
    <path
      d="M24 16H8M8 16L16 24M8 16L16 8"
      stroke="#009F06"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const StepSeparatorIcon = (props: IconProps) => (
  <Icon
    width="131px"
    height="4px"
    viewBox="0 0 131 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 2L131 2"
      stroke="url(#paint0_linear_553_8938)"
      strokeWidth="4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_553_8938"
        x1="0"
        y1="1.5"
        x2="131"
        y2="1.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C707" />
        <stop offset="0.789266" stopColor="white" />
      </linearGradient>
    </defs>
  </Icon>
);

export const AddIcon = (props: IconProps) => (
  <Icon
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.25 8.25H3.75C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75H14.25C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25Z"
      fill="white"
    />
    <path
      d="M9.75 14.25L9.75 3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75L8.25 14.25C8.25 14.6642 8.58579 15 9 15C9.41421 15 9.75 14.6642 9.75 14.25Z"
      fill="white"
    />
  </Icon>
);

export const AddNewIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 6V26M26 16L6 16"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const SearchIcon = (props: IconProps) => (
  <Icon
    width="15px"
    height="14px"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx="6.79614"
      cy="6.33333"
      rx="5.55102"
      ry="5.33333"
      stroke="#656B76"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7347 12.9996L10.7163 10.0996"
      stroke="#656B76"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const EllipsesVerticalIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8ZM14 16C14 14.8954 14.8954 14 16 14C17.1046 14 18 14.8954 18 16C18 17.1046 17.1046 18 16 18C14.8954 18 14 17.1046 14 16ZM14 24C14 22.8954 14.8954 22 16 22C17.1046 22 18 22.8954 18 24C18 25.1046 17.1046 26 16 26C14.8954 26 14 25.1046 14 24Z"
      fill="#0F172A"
    />
  </Icon>
);

export const PencilSquareMiniIcon = (props: IconProps) => (
  <Icon
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.71653 6.95814L3.34742 5.38091C3.44802 5.12943 3.59864 4.901 3.79016 4.70948L7.24976 1.25011C7.66397 0.835899 8.33554 0.8359 8.74976 1.25011C9.16397 1.66433 9.16397 2.3359 8.74976 2.75011L5.29016 6.20948C5.09864 6.401 4.87021 6.55163 4.61873 6.65222L3.0415 7.2831C2.83742 7.36474 2.6349 7.16222 2.71653 6.95814Z"
      fill="#1A1C1F"
    />
    <path
      d="M1.75 2.87476C1.75 2.52958 2.02982 2.24976 2.375 2.24976H5C5.20711 2.24976 5.375 2.08186 5.375 1.87476C5.375 1.66765 5.20711 1.49976 5 1.49976H2.375C1.61561 1.49976 1 2.11536 1 2.87476V7.62476C1 8.38415 1.61561 8.99976 2.375 8.99976H7.125C7.88439 8.99976 8.5 8.38415 8.5 7.62476V4.99976C8.5 4.79265 8.33211 4.62476 8.125 4.62476C7.91789 4.62476 7.75 4.79265 7.75 4.99976V7.62476C7.75 7.96993 7.47018 8.24976 7.125 8.24976H2.375C2.02982 8.24976 1.75 7.96993 1.75 7.62476V2.87476Z"
      fill="#1A1C1F"
    />
  </Icon>
);

export const TrashMiniIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 1C7.23122 1 6 2.23122 6 3.75V4.1927C5.20472 4.26972 4.41602 4.36947 3.63458 4.49129C3.22531 4.5551 2.94525 4.9386 3.00906 5.34787C3.07286 5.75714 3.45637 6.0372 3.86564 5.97339L4.01355 5.95062L4.85504 16.4693C4.96938 17.8985 6.16254 19 7.59629 19H12.4035C13.8372 19 15.0304 17.8985 15.1447 16.4693L15.9862 5.95055L16.1346 5.97339C16.5438 6.0372 16.9274 5.75714 16.9912 5.34787C17.055 4.9386 16.7749 4.5551 16.3656 4.49129C15.5841 4.36946 14.7954 4.2697 14 4.19268V3.75C14 2.23122 12.7688 1 11.25 1H8.75ZM10.0001 4C10.8395 4 11.673 4.02523 12.5 4.07499V3.75C12.5 3.05964 11.9404 2.5 11.25 2.5H8.75C8.05964 2.5 7.5 3.05964 7.5 3.75V4.075C8.32707 4.02524 9.16068 4 10.0001 4ZM8.57948 7.72002C8.56292 7.30614 8.21398 6.98404 7.8001 7.0006C7.38622 7.01716 7.06412 7.36609 7.08068 7.77998L7.38069 15.28C7.39725 15.6939 7.74619 16.016 8.16007 15.9994C8.57395 15.9828 8.89605 15.6339 8.87949 15.22L8.57948 7.72002ZM12.9195 7.77998C12.936 7.36609 12.614 7.01715 12.2001 7.0006C11.7862 6.98404 11.4372 7.30614 11.4207 7.72002L11.1207 15.22C11.1041 15.6339 11.4262 15.9828 11.8401 15.9994C12.254 16.016 12.6029 15.6939 12.6195 15.28L12.9195 7.77998Z"
      fill="#0F172A"
    />
  </Icon>
);

export const TrashMiniRedIcon = (props: IconProps) => (
  <Icon
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.375 0.5C3.61561 0.5 3 1.11561 3 1.875V2.09635C2.60236 2.13486 2.20801 2.18473 1.81729 2.24565C1.61265 2.27755 1.47263 2.4693 1.50453 2.67394C1.53643 2.87857 1.72818 3.0186 1.93282 2.9867L2.00677 2.97531L2.42752 8.23465C2.48469 8.94924 3.08127 9.5 3.79814 9.5H6.20175C6.91862 9.5 7.51521 8.94924 7.57237 8.23465L7.99312 2.97528L8.06729 2.9867C8.27192 3.0186 8.46368 2.87857 8.49558 2.67394C8.52748 2.4693 8.38745 2.27755 8.18282 2.24565C7.79206 2.18473 7.39768 2.13485 7 2.09634V1.875C7 1.11561 6.38439 0.5 5.625 0.5H4.375ZM5.00005 2C5.41973 2 5.8365 2.01262 6.25 2.03749V1.875C6.25 1.52982 5.97018 1.25 5.625 1.25H4.375C4.02982 1.25 3.75 1.52982 3.75 1.875V2.0375C4.16353 2.01262 4.58034 2 5.00005 2ZM4.16484 3.86501C4.15932 3.72705 4.04301 3.61968 3.90505 3.6252C3.76709 3.63072 3.65972 3.74703 3.66524 3.88499L3.81525 7.63499C3.82076 7.77295 3.93708 7.88032 4.07504 7.8748C4.213 7.86928 4.32036 7.75297 4.31485 7.61501L4.16484 3.86501ZM6.33485 3.88499C6.34036 3.74703 6.233 3.63072 6.09504 3.6252C5.95708 3.61968 5.84076 3.72705 5.83525 3.86501L5.68525 7.61501C5.67973 7.75297 5.78709 7.86928 5.92505 7.8748C6.06301 7.88032 6.17933 7.77295 6.18485 7.63499L6.33485 3.88499Z"
      fill="#E54839"
    />
  </Icon>
);

export const UserPlusIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 5C10 6.65685 8.65685 8 7 8C5.34315 8 4 6.65685 4 5C4 3.34315 5.34315 2 7 2C8.65685 2 10 3.34315 10 5Z"
      fill="#009F06"
    />
    <path
      d="M1.61528 16.428C1.21798 16.1736 0.987847 15.721 1.04605 15.2529C1.41416 12.292 3.93944 10 6.9999 10C10.0604 10 12.5856 12.2914 12.9537 15.2522C13.012 15.7203 12.7818 16.1729 12.3845 16.4273C10.8302 17.4225 8.98243 18 6.9999 18C5.01737 18 3.16959 17.4231 1.61528 16.428Z"
      fill="#009F06"
    />
    <path
      d="M16.25 5.75C16.25 5.33579 15.9142 5 15.5 5C15.0858 5 14.75 5.33579 14.75 5.75V7.75H12.75C12.3358 7.75 12 8.08579 12 8.5C12 8.91421 12.3358 9.25 12.75 9.25H14.75V11.25C14.75 11.6642 15.0858 12 15.5 12C15.9142 12 16.25 11.6642 16.25 11.25V9.25H18.25C18.6642 9.25 19 8.91421 19 8.5C19 8.08579 18.6642 7.75 18.25 7.75H16.25V5.75Z"
      fill="#009F06"
    />
  </Icon>
);

export const ReceiptTwoToneIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 6V8.42C22 10 21 11 19.42 11H16V4.01C16 2.9 16.91 2 18.02 2C19.11 2.01 20.11 2.45 20.83 3.17C21.55 3.9 22 4.9 22 6Z"
      stroke="#C06C00"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 7V21C2 21.83 2.94 22.3 3.6 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.29 22.29C8.68 22.68 9.32 22.68 9.71 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7H6C3 2 2 3.79 2 6V7Z"
      stroke="#C06C00"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M9 13.0098H12"
      stroke="#C06C00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M9 9.00977H12"
      stroke="#C06C00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M5.99561 13H6.00459"
      stroke="#C06C00"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M5.99548 9H6.00447"
      stroke="#C06C00"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ErrorIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.51 3.85L11.57 0.42C10.6 -0.14 9.40004 -0.14 8.42004 0.42L2.49004 3.85C1.52004 4.41 0.920044 5.45 0.920044 6.58V13.42C0.920044 14.54 1.52004 15.58 2.49004 16.15L8.43004 19.58C9.40004 20.14 10.6 20.14 11.58 19.58L17.52 16.15C18.49 15.59 19.09 14.55 19.09 13.42V6.58C19.08 5.45 18.48 4.42 17.51 3.85ZM9.25004 5.75C9.25004 5.34 9.59004 5 10 5C10.41 5 10.75 5.34 10.75 5.75V11C10.75 11.41 10.41 11.75 10 11.75C9.59004 11.75 9.25004 11.41 9.25004 11V5.75ZM10.92 14.63C10.87 14.75 10.8 14.86 10.71 14.96C10.52 15.15 10.27 15.25 10 15.25C9.87004 15.25 9.74004 15.22 9.62004 15.17C9.49004 15.12 9.39004 15.05 9.29004 14.96C9.20004 14.86 9.13004 14.75 9.07004 14.63C9.02004 14.51 9.00004 14.38 9.00004 14.25C9.00004 13.99 9.10004 13.73 9.29004 13.54C9.39004 13.45 9.49004 13.38 9.62004 13.33C9.99004 13.17 10.43 13.26 10.71 13.54C10.8 13.64 10.87 13.74 10.92 13.87C10.97 13.99 11 14.12 11 14.25C11 14.38 10.97 14.51 10.92 14.63Z"
      fill="#DB4343"
    />
  </Icon>
);

export const EllipsisHorizontalIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 13.5C5.17157 13.5 4.5 12.8284 4.5 12C4.5 11.1716 5.17157 10.5 6 10.5C6.82843 10.5 7.5 11.1716 7.5 12C7.5 12.8284 6.82843 13.5 6 13.5ZM12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5ZM18 13.5C17.1716 13.5 16.5 12.8284 16.5 12C16.5 11.1716 17.1716 10.5 18 10.5C18.8284 10.5 19.5 11.1716 19.5 12C19.5 12.8284 18.8284 13.5 18 13.5Z"
      fill="#0F172A"
    />
  </Icon>
);

export const AgencyAccountIcon = (props?: IconProps) => (
  <Icon
    width="32px"
    height="40px"
    viewBox="0 0 32 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.74987 9C7.74987 4.44365 11.4435 0.75 15.9999 0.75C20.5562 0.75 24.2499 4.44365 24.2499 9C24.2499 13.5563 20.5562 17.25 15.9999 17.25C11.4435 17.25 7.74987 13.5563 7.74987 9Z"
      fill="#0F172A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.877158 34.8598C1.01895 26.6285 7.73518 20 15.9999 20C24.2648 20 30.9811 26.6289 31.1226 34.8604C31.132 35.4063 30.8175 35.906 30.3212 36.1337C25.9599 38.135 21.1085 39.25 16.0005 39.25C10.892 39.25 6.04017 38.1348 1.67846 36.1331C1.18224 35.9054 0.867755 35.4057 0.877158 34.8598Z"
      fill="#0F172A"
    />
  </Icon>
);

export const WalletIconWithBg = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#A8EEAA"
    />
    <path
      d="M28 16C28 14.3431 26.6569 13 25 13H20C20 15.2091 18.2091 17 16 17C13.7909 17 12 15.2091 12 13H7C5.34315 13 4 14.3431 4 16M28 16V24C28 25.6568 26.6569 27 25 27H7C5.34315 27 4 25.6568 4 24V16M28 16V12M4 16V12M28 12C28 10.3431 26.6569 8.99998 25 8.99998H7C5.34315 8.99998 4 10.3431 4 12M28 12V7.99998C28 6.34313 26.6569 4.99998 25 4.99998H7C5.34315 4.99998 4 6.34313 4 7.99998V12"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowUpRightIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.75 16.25L16.25 3.75M16.25 3.75L6.875 3.75M16.25 3.75V13.125"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const PlusIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 3.75V16.25M16.25 10L3.75 10"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const EyeOpenMiniIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      fill="#0F172A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.797106 12.7085C0.62087 12.2505 0.621022 11.7428 0.797532 11.2849C2.53054 6.78946 6.89195 3.6 11.9983 3.6C17.1072 3.6 21.4704 6.79261 23.2016 11.2915C23.3779 11.7495 23.3777 12.2572 23.2012 12.7151C21.4682 17.2105 17.1068 20.4 12.0004 20.4C6.89157 20.4 2.52837 17.2074 0.797106 12.7085ZM16.8004 12C16.8004 14.651 14.6514 16.8 12.0004 16.8C9.34948 16.8 7.20045 14.651 7.20045 12C7.20045 9.34903 9.34948 7.2 12.0004 7.2C14.6514 7.2 16.8004 9.34903 16.8004 12Z"
      fill="#0F172A"
    />
  </Icon>
);

export const ArrowTrendingUpWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M3 24L12 15L17.7419 20.7419C19.3468 17.5841 22.0056 14.9364 25.4937 13.3834L29.1479 11.7564M29.1479 11.7564L21.2262 8.71556M29.1479 11.7564L26.107 19.6781"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const HumansIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M20 25.5034C21.1106 25.8267 22.285 26 23.4999 26C25.4716 26 27.3367 25.5435 28.9952 24.7304C28.9983 24.654 28.9999 24.5772 28.9999 24.5C28.9999 21.4624 26.5375 19 23.4999 19C21.6092 19 19.9414 19.954 18.9514 21.4069M20 25.5034V25.5C20 24.0161 19.6198 22.6211 18.9514 21.4069M20 25.5034C20 25.5509 19.9996 25.5984 19.9988 25.6458C17.5165 27.1403 14.6086 28 11.5 28C8.39137 28 5.48352 27.1403 3.00123 25.6458C3.00041 25.5973 3 25.5487 3 25.5C3 20.8056 6.80558 17 11.5 17C14.7106 17 17.5054 18.78 18.9514 21.4069M16 8.5C16 10.9853 13.9853 13 11.5 13C9.01472 13 7 10.9853 7 8.5C7 6.01472 9.01472 4 11.5 4C13.9853 4 16 6.01472 16 8.5ZM27 11.5C27 13.433 25.433 15 23.5 15C21.567 15 20 13.433 20 11.5C20 9.567 21.567 8 23.5 8C25.433 8 27 9.567 27 11.5Z"
      stroke="#0F172A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowUpGreenIcon = (props: IconProps) => (
  <Icon
    width="17px"
    height="16px"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.49999 13.6C8.16862 13.6 7.89999 13.3314 7.89999 13L7.89999 4.48966L4.73249 7.81586C4.50281 8.05473 4.12298 8.06218 3.88412 7.8325C3.64526 7.60282 3.63781 7.223 3.86749 6.98413L8.06749 2.58413C8.18061 2.46649 8.33678 2.4 8.49999 2.4C8.6632 2.4 8.81936 2.46649 8.93249 2.58413L13.1325 6.98413C13.3622 7.223 13.3547 7.60282 13.1159 7.8325C12.877 8.06217 12.4972 8.05473 12.2675 7.81586L9.09999 4.48966L9.09999 13C9.09999 13.3314 8.83136 13.6 8.49999 13.6Z"
      fill="#2C974A"
    />
  </Icon>
);

export const ArrowDownRedIcon = (props: IconProps) => (
  <Icon
    width="17px"
    height="16px"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.50001 2.4C8.83138 2.4 9.10001 2.66863 9.10001 3L9.10001 11.5103L12.2675 8.18414C12.4972 7.94527 12.877 7.93783 13.1159 8.1675C13.3547 8.39718 13.3622 8.777 13.1325 9.01587L8.93251 13.4159C8.81939 13.5335 8.66322 13.6 8.50001 13.6C8.3368 13.6 8.18064 13.5335 8.06751 13.4159L3.86751 9.01587C3.63784 8.777 3.64528 8.39718 3.88415 8.1675C4.12301 7.93783 4.50284 7.94527 4.73251 8.18414L7.90001 11.5103L7.90001 3C7.90001 2.66863 8.16864 2.4 8.50001 2.4Z"
      fill="#911D11"
    />
  </Icon>
);

export const ArrowRightIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="18px"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9697 0.96967C11.2626 0.676777 11.7374 0.676777 12.0303 0.96967L19.5303 8.46967C19.671 8.61032 19.75 8.80109 19.75 9C19.75 9.19891 19.671 9.38968 19.5303 9.53033L12.0303 17.0303C11.7374 17.3232 11.2626 17.3232 10.9697 17.0303C10.6768 16.7374 10.6768 16.2626 10.9697 15.9697L17.1893 9.75H1C0.585786 9.75 0.25 9.41421 0.25 9C0.25 8.58579 0.585786 8.25 1 8.25H17.1893L10.9697 2.03033C10.6768 1.73744 10.6768 1.26256 10.9697 0.96967Z"
      fill="#0F172A"
    />
  </Icon>
);

export const RectangleGroupWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M3 9.49998C3 8.67156 3.67157 7.99998 4.5 7.99998H12.5C13.3284 7.99998 14 8.67156 14 9.49998V14.5C14 15.3284 13.3284 16 12.5 16H4.5C3.67157 16 3 15.3284 3 14.5V9.49998Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 11.5C19 10.6716 19.6716 9.99998 20.5 9.99998H27.5C28.3284 9.99998 29 10.6716 29 11.5V22.5C29 23.3284 28.3284 24 27.5 24H20.5C19.6716 24 19 23.3284 19 22.5V11.5Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 21.5C5 20.6716 5.67157 20 6.5 20H13.5C14.3284 20 15 20.6716 15 21.5V24.5C15 25.3284 14.3284 26 13.5 26H6.5C5.67157 26 5 25.3284 5 24.5V21.5Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const InformationCircleOutlineIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.375 9.375L9.40957 9.35771C9.88717 9.11891 10.4249 9.55029 10.2954 10.0683L9.70458 12.4317C9.57507 12.9497 10.1128 13.3811 10.5904 13.1423L10.625 13.125M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 6.875H10.0063V6.88125H10V6.875Z"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const PresentationChartWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M5 4V19C5 20.6569 6.34315 22 8 22H11M5 4H3M5 4H27M27 4H29M27 4V19C27 20.6569 25.6569 22 24 22H21M11 22H21M11 22L9.66667 26M21 22L22.3333 26M22.3333 26L23 28M22.3333 26H9.66667M9.66667 26L9 28M10 16L14 12L16.8635 14.8635C18.2056 12.9373 19.9605 11.3203 22 10.1405"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChartPieWithBgIcon = (props: IconProps) => (
  <Icon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M14 8C8.47718 8 4.00003 12.4772 4.00003 18C4.00003 23.5228 8.47718 28 14 28C19.5229 28 24 23.5228 24 18H14V8Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 14H28C28 8.47715 23.5229 4 18 4V14Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const QueueListWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M5 16H27M5 21H27M5 26H27M7.5 6H24.5C25.8807 6 27 7.11929 27 8.5C27 9.88071 25.8807 11 24.5 11H7.5C6.11929 11 5 9.88071 5 8.5C5 7.11929 6.11929 6 7.5 6Z"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const AngleRightGreenIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.83 11.29L10.59 7.05001C10.497 6.95628 10.3864 6.88189 10.2646 6.83112C10.1427 6.78035 10.012 6.75421 9.88 6.75421C9.74799 6.75421 9.61729 6.78035 9.49543 6.83112C9.37357 6.88189 9.26297 6.95628 9.17 7.05001C8.98375 7.23737 8.87921 7.49082 8.87921 7.75501C8.87921 8.0192 8.98375 8.27265 9.17 8.46001L12.71 12L9.17 15.54C8.98375 15.7274 8.87921 15.9808 8.87921 16.245C8.87921 16.5092 8.98375 16.7626 9.17 16.95C9.26344 17.0427 9.37426 17.116 9.4961 17.1658C9.61794 17.2155 9.7484 17.2408 9.88 17.24C10.0116 17.2408 10.1421 17.2155 10.2639 17.1658C10.3857 17.116 10.4966 17.0427 10.59 16.95L14.83 12.71C14.9237 12.617 14.9981 12.5064 15.0489 12.3846C15.0997 12.2627 15.1258 12.132 15.1258 12C15.1258 11.868 15.0997 11.7373 15.0489 11.6154C14.9981 11.4936 14.9237 11.383 14.83 11.29Z"
      fill="#009F06"
    />
  </Icon>
);

export const DepositsIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.45 18.2175C7.45 18.5213 7.69624 18.7675 8 18.7675C8.30376 18.7675 8.55 18.5213 8.55 18.2175H7.45ZM8.18437 8.28982L8.64843 7.99461L8.18437 8.28982ZM14.3156 17.9277L14.7797 17.6325L14.7797 17.6325L14.3156 17.9277ZM15.05 8C15.05 7.69624 14.8038 7.45 14.5 7.45C14.1962 7.45 13.95 7.69624 13.95 8H15.05ZM5 13.45C4.69624 13.45 4.45 13.6962 4.45 14C4.45 14.3038 4.69624 14.55 5 14.55V13.45ZM17 14.55C17.3038 14.55 17.55 14.3038 17.55 14C17.55 13.6962 17.3038 13.45 17 13.45V14.55ZM5 10.45C4.69624 10.45 4.45 10.6962 4.45 11C4.45 11.3038 4.69624 11.55 5 11.55V10.45ZM17 11.55C17.3038 11.55 17.55 11.3038 17.55 11C17.55 10.6962 17.3038 10.45 17 10.45V11.55ZM21.55 12C21.55 11.6962 21.3038 11.45 21 11.45C20.6962 11.45 20.45 11.6962 20.45 12H21.55ZM11 2.55C11.3038 2.55 11.55 2.30376 11.55 2C11.55 1.69624 11.3038 1.45 11 1.45V2.55ZM16.55 3C16.55 2.69624 16.3038 2.45 16 2.45C15.6962 2.45 15.45 2.69624 15.45 3H16.55ZM16 7H15.45C15.45 7.30376 15.6962 7.55 16 7.55V7ZM20 7.55C20.3038 7.55 20.55 7.30376 20.55 7C20.55 6.69624 20.3038 6.45 20 6.45V7.55ZM21.3889 2.38891C21.6037 2.17412 21.6037 1.82588 21.3889 1.61109C21.1741 1.3963 20.8259 1.3963 20.6111 1.61109L21.3889 2.38891ZM8.55 18.2175V14H7.45V18.2175H8.55ZM8.55 14V11H7.45V14H8.55ZM8.55 11V8.3435H7.45V11H8.55ZM7.72032 8.58504L9.44443 11.2952L10.3725 10.7048L8.64843 7.99461L7.72032 8.58504ZM9.44443 11.2952L11.3529 14.2952L12.281 13.7048L10.3725 10.7048L9.44443 11.2952ZM11.3529 14.2952L13.8516 18.2229L14.7797 17.6325L12.281 13.7048L11.3529 14.2952ZM15.05 17.874V14H13.95V17.874H15.05ZM15.05 14V11H13.95V14H15.05ZM15.05 11V8H13.95V11H15.05ZM13.8516 18.2229C14.2006 18.7716 15.05 18.5244 15.05 17.874H13.95C13.95 17.4238 14.538 17.2526 14.7797 17.6325L13.8516 18.2229ZM8.55 8.3435C8.55 8.79374 7.96198 8.96491 7.72032 8.58504L8.64843 7.99461C8.29936 7.4459 7.45 7.69315 7.45 8.3435H8.55ZM5 14.55H8V13.45H5V14.55ZM8 14.55H11.817V13.45H8V14.55ZM11.817 14.55H14.5V13.45H11.817V14.55ZM14.5 14.55H17V13.45H14.5V14.55ZM5 11.55H8V10.45H5V11.55ZM8 11.55H9.90849V10.45H8V11.55ZM9.90849 11.55H14.5V10.45H9.90849V11.55ZM14.5 11.55H17V10.45H14.5V11.55ZM20.45 12C20.45 17.2162 16.2162 21.45 11 21.45V22.55C16.8238 22.55 21.55 17.8238 21.55 12H20.45ZM11 21.45C5.78376 21.45 1.55 17.2162 1.55 12H0.45C0.45 17.8238 5.17624 22.55 11 22.55V21.45ZM1.55 12C1.55 6.78376 5.78376 2.55 11 2.55V1.45C5.17624 1.45 0.45 6.17624 0.45 12H1.55ZM15.45 3V7H16.55V3H15.45ZM16 7.55H20V6.45H16V7.55ZM20.6111 1.61109L15.6111 6.61109L16.3889 7.38891L21.3889 2.38891L20.6111 1.61109Z"
      fill="#292D32"
    />
  </Icon>
);

export const WithdrawalsIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.45 18.2175C7.45 18.5213 7.69624 18.7675 8 18.7675C8.30376 18.7675 8.55 18.5213 8.55 18.2175H7.45ZM8.18437 8.28982L8.64843 7.99461L8.18437 8.28982ZM14.3156 17.9277L14.7797 17.6325L14.7797 17.6325L14.3156 17.9277ZM15.05 8C15.05 7.69624 14.8038 7.45 14.5 7.45C14.1962 7.45 13.95 7.69624 13.95 8H15.05ZM5 13.45C4.69624 13.45 4.45 13.6962 4.45 14C4.45 14.3038 4.69624 14.55 5 14.55V13.45ZM17 14.55C17.3038 14.55 17.55 14.3038 17.55 14C17.55 13.6962 17.3038 13.45 17 13.45V14.55ZM5 10.45C4.69624 10.45 4.45 10.6962 4.45 11C4.45 11.3038 4.69624 11.55 5 11.55V10.45ZM17 11.55C17.3038 11.55 17.55 11.3038 17.55 11C17.55 10.6962 17.3038 10.45 17 10.45V11.55ZM21.55 12C21.55 11.6962 21.3038 11.45 21 11.45C20.6962 11.45 20.45 11.6962 20.45 12H21.55ZM11 2.55C11.3038 2.55 11.55 2.30376 11.55 2C11.55 1.69624 11.3038 1.45 11 1.45V2.55ZM18.0682 0.454247C17.7668 0.416571 17.4919 0.63037 17.4542 0.931781C17.4166 1.23319 17.6304 1.50808 17.9318 1.54575L18.0682 0.454247ZM22 1.5L22.5445 1.57778C22.5653 1.43172 22.5266 1.28341 22.4371 1.16615C22.3475 1.0489 22.2146 0.972547 22.0682 0.954247L22 1.5ZM20.9555 4.92222C20.9126 5.22292 21.1215 5.50151 21.4222 5.54447C21.7229 5.58743 22.0015 5.37849 22.0445 5.07778L20.9555 4.92222ZM15.67 5.56C15.427 5.74225 15.3777 6.08699 15.56 6.33C15.7423 6.57301 16.087 6.62225 16.33 6.44L15.67 5.56ZM8.55 18.2175V14H7.45V18.2175H8.55ZM8.55 14V11H7.45V14H8.55ZM8.55 11V8.3435H7.45V11H8.55ZM7.72032 8.58504L9.44443 11.2952L10.3725 10.7048L8.64843 7.99461L7.72032 8.58504ZM9.44443 11.2952L11.3529 14.2952L12.281 13.7048L10.3725 10.7048L9.44443 11.2952ZM11.3529 14.2952L13.8516 18.2229L14.7797 17.6325L12.281 13.7048L11.3529 14.2952ZM15.05 17.874V14H13.95V17.874H15.05ZM15.05 14V11H13.95V14H15.05ZM15.05 11V8H13.95V11H15.05ZM13.8516 18.2229C14.2006 18.7716 15.05 18.5244 15.05 17.874H13.95C13.95 17.4238 14.538 17.2526 14.7797 17.6325L13.8516 18.2229ZM8.55 8.3435C8.55 8.79374 7.96198 8.96491 7.72032 8.58504L8.64843 7.99461C8.29936 7.4459 7.45 7.69315 7.45 8.3435H8.55ZM5 14.55H8V13.45H5V14.55ZM8 14.55H11.817V13.45H8V14.55ZM11.817 14.55H14.5V13.45H11.817V14.55ZM14.5 14.55H17V13.45H14.5V14.55ZM5 11.55H8V10.45H5V11.55ZM8 11.55H9.90849V10.45H8V11.55ZM9.90849 11.55H14.5V10.45H9.90849V11.55ZM14.5 11.55H17V10.45H14.5V11.55ZM20.45 12C20.45 17.2162 16.2162 21.45 11 21.45V22.55C16.8238 22.55 21.55 17.8238 21.55 12H20.45ZM11 21.45C5.78376 21.45 1.55 17.2162 1.55 12H0.45C0.45 17.8238 5.17624 22.55 11 22.55V21.45ZM1.55 12C1.55 6.78376 5.78376 2.55 11 2.55V1.45C5.17624 1.45 0.45 6.17624 0.45 12H1.55ZM17.9318 1.54575L21.9318 2.04575L22.0682 0.954247L18.0682 0.454247L17.9318 1.54575ZM21.4555 1.42222L20.9555 4.92222L22.0445 5.07778L22.5445 1.57778L21.4555 1.42222ZM16.33 6.44L22.33 1.94L21.67 1.06L15.67 5.56L16.33 6.44Z"
      fill="#292D32"
    />
  </Icon>
);

export const QRIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 17V16H13V13H16V15H18V17H17V19H15V21H13V18H15V17H16ZM21 21H17V19H19V17H21V21ZM3 3H11V11H3V3ZM5 5V9H9V5H5ZM13 3H21V11H13V3ZM15 5V9H19V5H15ZM3 13H11V21H3V13ZM5 15V19H9V15H5ZM18 13H21V15H18V13ZM6 6H8V8H6V6ZM6 16H8V18H6V16ZM16 6H18V8H16V6Z"
      fill="black"
    />
  </Icon>
);

export const RectangleStackWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M8 9.17071V8C8 6.34315 9.34315 5 11 5H21C22.6569 5 24 6.34315 24 8V9.17071M8 9.17071C8.31278 9.06015 8.64936 9 9 9H23C23.3506 9 23.6872 9.06015 24 9.17071M8 9.17071C6.83481 9.58254 6 10.6938 6 12V13.1707M24 9.17071C25.1652 9.58254 26 10.6938 26 12V13.1707M26 13.1707C25.6872 13.0602 25.3506 13 25 13H7C6.64936 13 6.31278 13.0602 6 13.1707M26 13.1707C27.1652 13.5825 28 14.6938 28 16V24C28 25.6569 26.6569 27 25 27H7C5.34315 27 4 25.6569 4 24V16C4 14.6938 4.83481 13.5825 6 13.1707"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ClockOutlineIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 6V12H16.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="#F3F7FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const BoltWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M5 18L19 3L16 14H27L13 29L16 18H5Z"
      stroke="#0F172A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowRightOnRectangleWithBgIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill="#E0E3E6"
    />
    <path
      d="M21 12V7C21 5.34315 19.6569 4 18 4L10 4C8.34315 4 7 5.34315 7 7L7 25C7 26.6569 8.34315 28 10 28H18C19.6569 28 21 26.6569 21 25V20M25 20L29 16M29 16L25 12M29 16L12 16"
      stroke="#0F172A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CalendarIcon = (props: IconProps) => (
  <Icon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#737983"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.75 3V5.25M17.25 3V5.25M3 18.75V7.5C3 6.25736 4.00736 5.25 5.25 5.25H18.75C19.9926 5.25 21 6.25736 21 7.5V18.75M3 18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75M3 18.75V11.25C3 10.0074 4.00736 9 5.25 9H18.75C19.9926 9 21 10.0074 21 11.25V18.75M12 12.75H12.0075V12.7575H12V12.75ZM12 15H12.0075V15.0075H12V15ZM12 17.25H12.0075V17.2575H12V17.25ZM9.75 15H9.7575V15.0075H9.75V15ZM9.75 17.25H9.7575V17.2575H9.75V17.25ZM7.5 15H7.5075V15.0075H7.5V15ZM7.5 17.25H7.5075V17.2575H7.5V17.25ZM14.25 12.75H14.2575V12.7575H14.25V12.75ZM14.25 15H14.2575V15.0075H14.25V15ZM14.25 17.25H14.2575V17.2575H14.25V17.25ZM16.5 12.75H16.5075V12.7575H16.5V12.75ZM16.5 15H16.5075V15.0075H16.5V15Z"
      stroke="#F3F7FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const PlusOutlineIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 6V26M26 16L6 16"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowUpTray = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 13.75V15.625C2.5 16.6605 3.33947 17.5 4.375 17.5H15.625C16.6605 17.5 17.5 16.6605 17.5 15.625V13.75M6.25 6.25L10 2.5M10 2.5L13.75 6.25M10 2.5L10 13.75"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const WalletIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 12C21 10.7574 19.9926 9.75 18.75 9.75H15C15 11.4069 13.6569 12.75 12 12.75C10.3431 12.75 9 11.4069 9 9.75H5.25C4.00736 9.75 3 10.7574 3 12M21 12V18C21 19.2426 19.9926 20.25 18.75 20.25H5.25C4.00736 20.25 3 19.2426 3 18V12M21 12V9M3 12V9M21 9C21 7.75736 19.9926 6.75 18.75 6.75H5.25C4.00736 6.75 3 7.75736 3 9M21 9V6C21 4.75736 19.9926 3.75 18.75 3.75H5.25C4.00736 3.75 3 4.75736 3 6V9"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const WalletIconWithColorBg = ({
  fill,
  ...props
}: { fill: string } & IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      transform="rotate(90 12 12)"
      fill={fill ?? "#CDBEFA"}
    />
    <path
      d="M28 16C28 14.3431 26.6569 13 25 13H20C20 15.2091 18.2092 17 16 17C13.7909 17 12 15.2091 12 13H7.00002C5.34317 13 4.00002 14.3431 4.00002 16M28 16V24C28 25.6569 26.6569 27 25 27H7.00002C5.34317 27 4.00002 25.6569 4.00002 24V16M28 16V12M4.00002 16V12M28 12C28 10.3431 26.6569 9 25 9H7.00002C5.34317 9 4.00002 10.3431 4.00002 12M28 12V8C28 6.34315 26.6569 5 25 5H7.00002C5.34317 5 4.00002 6.34315 4.00002 8V12"
      stroke="#1A1C1F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChartRoseIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.713 7.97461C6.60492 7.97461 4.08533 10.2303 4.08533 13.0129H9.713V7.97461Z"
      stroke="#141B34"
      strokeWidth="1.5"
    />
    <path
      d="M2.53453 15.9261C3.77319 18.3681 6.52105 20.0663 9.71196 20.0663L9.71196 13.0128H4.87217C3.40834 13.0128 2.67643 13.0128 2.23141 13.732C1.78639 14.4512 2.03577 14.9428 2.53453 15.9261Z"
      stroke="#141B34"
      strokeWidth="1.5"
    />
    <path
      d="M12.7146 21.6766C16.8432 20.5311 19.842 17.0854 19.842 13.0127H9.71216V19.0586C9.71216 20.5322 9.71216 21.269 10.3128 21.7226C10.9134 22.1763 11.5138 22.0097 12.7146 21.6766Z"
      stroke="#141B34"
      strokeWidth="1.5"
    />
    <path
      d="M21.6409 10.0343C20.4535 6.21439 17.0382 3.22528 12.7272 2.25958C11.4777 1.97968 10.8529 1.83973 10.2825 2.29354C9.71216 2.74735 9.71216 3.48208 9.71216 4.95155V13.0127H19.0541C20.534 13.0127 21.2739 13.0127 21.7294 12.3984C22.1849 11.784 22.0036 11.2008 21.6409 10.0343Z"
      stroke="#141B34"
      strokeWidth="1.5"
    />
  </Icon>
);

export const FileIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.5 10C3.5 6.22876 3.5 4.34315 4.7448 3.17157C5.98959 2 7.99306 2 12 2H12.7727C16.0339 2 17.6645 2 18.7969 2.79784C19.1214 3.02643 19.4094 3.29752 19.6523 3.60289C20.5 4.66867 20.5 6.20336 20.5 9.27273V11.8182C20.5 14.7814 20.5 16.2629 20.0311 17.4462C19.2772 19.3486 17.6829 20.8491 15.6616 21.5586C14.4044 22 12.8302 22 9.68182 22C7.88275 22 6.98322 22 6.26478 21.7478C5.10979 21.3424 4.19875 20.4849 3.76796 19.3979C3.5 18.7217 3.5 17.8751 3.5 16.1818V10Z"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 12C20.5 13.8409 19.0076 15.3333 17.1667 15.3333C16.5009 15.3333 15.716 15.2167 15.0686 15.3901C14.4935 15.5442 14.0442 15.9935 13.8901 16.5686C13.7167 17.216 13.8333 18.0009 13.8333 18.6667C13.8333 20.5076 12.3409 22 10.5 22"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 7H15"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 11H11"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CreditCardWithDots = (props: IconProps) => (
  <Icon
    width="24pc"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 12C2 8.46252 2 6.69377 3.0528 5.5129C3.22119 5.32403 3.40678 5.14935 3.60746 4.99087C4.86213 4 6.74142 4 10.5 4H13.5C17.2586 4 19.1379 4 20.3925 4.99087C20.5932 5.14935 20.7788 5.32403 20.9472 5.5129C22 6.69377 22 8.46252 22 12C22 15.5375 22 17.3062 20.9472 18.4871C20.7788 18.676 20.5932 18.8506 20.3925 19.0091C19.1379 20 17.2586 20 13.5 20H10.5C6.74142 20 4.86213 20 3.60746 19.0091C3.40678 18.8506 3.22119 18.676 3.0528 18.4871C2 17.3062 2 15.5375 2 12Z"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 16H11.5"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 16L18 16"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 9H22"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ArrowLeftRightIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 21L3 16.5M3 16.5L7.5 12M3 16.5H16.5M16.5 3L21 7.5M21 7.5L16.5 12M21 7.5L7.5 7.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CircleArrowDiagonalIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="#141B34"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 16.5L7.5 7.5M16.5 16.5H12.5M16.5 16.5V12.5M7.5 7.5H11.5M7.5 7.5V11.5"
      stroke="#141B34"
      strokeWidth="1.5"
    />
  </Icon>
);

export const ApprovalBoltIcon = (props: IconProps) => (
  <Icon
    width="200px"
    height="200px"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10910_157977)">
      <path
        d="M134.21 160.9C135.56 160.9 136.65 161.99 136.65 163.34C136.65 164.69 135.56 165.78 134.21 165.78C132.86 165.78 131.77 164.69 131.77 163.34C131.77 161.99 132.86 160.9 134.21 160.9Z"
        stroke="#001419"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.57 24L70.55 40.48"
        stroke="#001419"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.81 32.26L62.31 32.24"
        stroke="#001419"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M154.987 49.16L156.948 53.1056L161.29 53.7476L158.139 56.8176L158.886 61.16L154.975 59.1056L151.088 61.16L151.812 56.8176L148.66 53.7476L153.026 53.1056L154.964 49.16H154.987Z"
        fill="#6D45E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.563 34.1012C118.471 35.1649 119.407 37.3925 118.833 39.4998L106.219 85.75H152.25C154.141 85.75 155.853 86.8722 156.606 88.6069C157.36 90.3417 157.013 92.3583 155.723 93.7411L89.2225 164.991C87.7321 166.588 85.3448 166.962 83.437 165.899C81.5292 164.835 80.5926 162.608 81.1674 160.5L93.781 114.25H47.75C45.8585 114.25 44.1474 113.128 43.3935 111.393C42.6397 109.658 42.9869 107.642 44.2775 106.259L110.777 35.009C112.268 33.4122 114.655 33.0376 116.563 34.1012Z"
        fill="#00C707"
      />
      <path
        d="M41.75 115.5L108.25 44.25L94 96.5H146.25L79.75 167.75L94 115.5H41.75Z"
        stroke="#556266"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10910_157977">
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const CloseIcon = (props: IconProps) => (
  <Icon
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="32" height="32" rx="16" fill="#F9FAFA" />
    <path
      d="M22.8571 9.14282L9.14282 22.8571M9.14282 9.14282L22.8571 22.8571"
      stroke="#C9CFD4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChartIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 19H8C4.70017 19 3.05025 19 2.02513 17.9749C1 16.9497 1 15.2998 1 12V1"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M5 2H6" stroke="#00111A" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M5 5H9" stroke="#00111A" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M3 18C4.07093 16.053 5.52279 11.0189 8.30628 11.0189C10.2301 11.0189 10.7283 13.4717 12.6136 13.4717C15.8572 13.4717 15.387 8 19 8"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const ChartRoseBorderedIcon = (props: IconProps) => (
  <Icon
    width="18px"
    height="22px"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 1.5V3C12 4.41421 12 5.12132 12.4393 5.56066C12.8787 6 13.5858 6 15 6H16.5"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 15L1 7C1 4.17157 1 2.75736 1.87868 1.87868C2.75736 1 4.17157 1 7 1L11.1716 1C11.5803 1 11.7847 1 11.9685 1.07612C12.1522 1.15224 12.2968 1.29676 12.5858 1.58579L16.4142 5.41421C16.7032 5.70324 16.8478 5.84776 16.9239 6.03153C17 6.2153 17 6.41968 17 6.82843L17 15C17 17.8284 17 19.2426 16.1213 20.1213C15.2426 21 13.8284 21 11 21L7 21C4.17157 21 2.75736 21 1.87868 20.1213C1 19.2426 1 17.8284 1 15Z"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 10L13 10M5 13L13 13M5 16H9.17084"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const DocumentAttachmentIcon = (props: IconProps) => (
  <Icon
    width="20px"
    height="22px"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 10V9C19 5.22876 19 3.34315 17.7595 2.17157C16.519 1 14.5225 1 10.5294 1L9.47059 1C5.47752 1 3.48098 1 2.24049 2.17157C1 3.34315 1 5.22876 1 9L1 13C1 16.7712 1 18.6569 2.24049 19.8284C3.48098 21 5.47751 21 9.47059 21H10"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6 6H14"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6 11H11"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19 19.6471L19 16C19 14.5706 17.6569 13 16 13C14.3431 13 13 14.5706 13 16L13 19.5C13 20.2797 13.7326 21 14.6364 21C15.5401 21 16.2727 20.2797 16.2727 19.5L16.2727 16.7647"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Icon>
);

export const DocumentPinnedIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 9.5V7.81818C20 6.12494 20 5.27832 19.732 4.60214C19.3012 3.5151 18.3902 2.65765 17.2352 2.2522C16.5168 2 15.6173 2 13.8182 2C10.6698 2 9.09563 2 7.83836 2.44135C5.81714 3.15089 4.22281 4.65142 3.46894 6.55375C3 7.73706 3 9.21865 3 12.1818V14.7273C3 17.7966 3 19.3313 3.8477 20.3971C4.09058 20.7025 4.37862 20.9736 4.70307 21.2022C5.83546 22 7.46607 22 10.7273 22H11.5C12.0347 22 13 22 13.5 21.9972"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17L7 17"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 13H10"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2498 22C17.2498 22.4142 17.5855 22.75 17.9998 22.75C18.414 22.75 18.7498 22.4142 18.7498 22H17.2498ZM18.7498 18.8878C18.7498 18.4736 18.414 18.1378 17.9998 18.1378C17.5855 18.1378 17.2498 18.4736 17.2498 18.8878H18.7498ZM15.49 18.2268L15.8859 17.5898L15.8859 17.5898L15.49 18.2268ZM20.5095 18.2268L20.1136 17.5898H20.1136L20.5095 18.2268ZM16.4755 13.5104L15.7547 13.7178L15.7547 13.7178L16.4755 13.5104ZM19.524 13.5104L20.2448 13.7178V13.7178L19.524 13.5104ZM15.8845 15.9638L16.3622 16.5419H16.3622L15.8845 15.9638ZM20.1015 15.9577L19.6283 16.5396L20.1015 15.9577ZM16.9511 12.2318L16.6362 11.5512H16.6362L16.9511 12.2318ZM19.0484 12.2318L19.3633 11.5512V11.5512L19.0484 12.2318ZM19.5886 12.6639L18.9118 12.9872V12.9872L19.5886 12.6639ZM16.4109 12.6639L17.0877 12.9872L16.4109 12.6639ZM19.1946 15.0749L18.4811 15.3059L18.4811 15.3059L19.1946 15.0749ZM16.8025 15.0608L17.517 15.2888V15.2888L16.8025 15.0608ZM15.065 17.8117L15.7544 17.5162L15.7544 17.5162L15.065 17.8117ZM20.9346 17.8117L21.6239 18.1074L21.6239 18.1074L20.9346 17.8117ZM18.7498 22L18.7498 18.8878H17.2498L17.2498 22H18.7498ZM15.094 18.8638C15.9431 19.3915 16.9867 19.6378 17.9997 19.6378C19.0128 19.6378 20.0564 19.3915 20.9054 18.8637L20.1136 17.5898C19.5447 17.9434 18.7875 18.1378 17.9997 18.1378C17.212 18.1378 16.4548 17.9434 15.8859 17.5898L15.094 18.8638ZM17.2661 12.9125C17.7344 12.6958 18.2651 12.6958 18.7334 12.9125L19.3633 11.5512C18.4954 11.1496 17.5041 11.1496 16.6362 11.5512L17.2661 12.9125ZM20.2448 13.7178C20.3389 13.3906 20.5234 12.8809 20.2653 12.3406L18.9118 12.9872C18.9091 12.9814 18.9028 12.9652 18.8997 12.9437C18.8969 12.9242 18.8993 12.9177 18.8974 12.9342C18.8951 12.9538 18.8888 12.9895 18.8723 13.0549C18.8556 13.1209 18.8336 13.1976 18.8033 13.303L20.2448 13.7178ZM18.7334 12.9125C18.8088 12.9474 18.856 12.9694 18.8947 12.9892C18.9313 13.0081 18.9422 13.016 18.9418 13.0157C18.9382 13.0131 18.9273 13.0042 18.9161 12.9904C18.9058 12.9778 18.9052 12.9732 18.9118 12.9872L20.2653 12.3406C20.1599 12.1199 20.0188 11.9447 19.8257 11.8038C19.6677 11.6886 19.4841 11.607 19.3633 11.5512L18.7334 12.9125ZM17.1963 13.303C17.1659 13.1976 17.1439 13.1209 17.1272 13.0549C17.1107 12.9895 17.1044 12.9538 17.1021 12.9343C17.1002 12.9177 17.1026 12.9243 17.0998 12.9437C17.0967 12.9652 17.0904 12.9815 17.0877 12.9872L15.7342 12.3406C15.4761 12.8809 15.6606 13.3906 15.7547 13.7178L17.1963 13.303ZM16.6362 11.5512C16.5154 11.6071 16.3318 11.6886 16.1738 11.8038C15.9807 11.9447 15.8396 12.1199 15.7342 12.3406L17.0877 12.9872C17.0944 12.9732 17.0937 12.9778 17.0834 12.9905C17.0723 13.0042 17.0613 13.0131 17.0577 13.0157C17.0573 13.016 17.0682 13.0081 17.1048 12.9892C17.1435 12.9694 17.1908 12.9474 17.2661 12.9125L16.6362 11.5512ZM20.5746 15.3758C20.2846 15.14 20.0985 14.988 19.9736 14.8712C19.9133 14.8148 19.8854 14.783 19.8747 14.7694C19.8637 14.7554 19.8881 14.7821 19.9081 14.8439L18.4811 15.3059C18.5775 15.6037 18.796 15.8236 18.9489 15.9666C19.121 16.1277 19.3563 16.3184 19.6283 16.5396L20.5746 15.3758ZM16.3622 16.5419C16.6387 16.3135 16.8762 16.1177 17.0494 15.9538C17.2013 15.8101 17.4217 15.5873 17.517 15.2888L16.088 14.8327C16.1084 14.7687 16.1336 14.7414 16.1213 14.7573C16.1095 14.7724 16.0802 14.8058 16.0183 14.8644C15.8907 14.9851 15.7006 15.1428 15.4067 15.3856L16.3622 16.5419ZM15.8859 17.5898C15.8264 17.5529 15.7905 17.5304 15.7612 17.5106C15.7339 17.4922 15.7271 17.4857 15.7289 17.4873C15.7331 17.4911 15.7422 17.5004 15.7509 17.5129C15.759 17.5243 15.7595 17.5282 15.7544 17.5162L14.3757 18.1073C14.4589 18.3013 14.5698 18.4618 14.7239 18.6009C14.8512 18.7158 14.9997 18.8051 15.094 18.8638L15.8859 17.5898ZM20.9054 18.8637C20.9999 18.8051 21.1483 18.7157 21.2756 18.6009C21.4296 18.4619 21.5406 18.3014 21.6239 18.1074L20.2454 17.516C20.2402 17.528 20.2408 17.5241 20.2488 17.5126C20.2576 17.5001 20.2666 17.4909 20.2708 17.4872C20.2725 17.4856 20.2657 17.4921 20.2383 17.5105C20.2091 17.5303 20.173 17.5528 20.1136 17.5898L20.9054 18.8637ZM15.4067 15.3856C15.1188 15.6236 14.7801 15.9989 14.5456 16.4301C14.3235 16.8384 14.1035 17.4723 14.3757 18.1073L15.7544 17.5162C15.7541 17.5157 15.7196 17.4109 15.8633 17.1467C15.9946 16.9054 16.2018 16.6745 16.3622 16.5419L15.4067 15.3856ZM21.6239 18.1074C21.8983 17.4677 21.6745 16.8307 21.4484 16.4207C21.21 15.9882 20.8662 15.6129 20.5746 15.3758L19.6283 16.5396C19.7912 16.672 20.0015 16.9031 20.1348 17.1449C20.2805 17.4091 20.246 17.5144 20.2454 17.516L21.6239 18.1074ZM17.517 15.2888C17.664 14.828 17.5449 14.3531 17.4578 14.0657C17.409 13.9042 17.3514 13.7467 17.3048 13.6188C17.2545 13.4807 17.2193 13.3831 17.1963 13.303L15.7547 13.7178C15.795 13.8579 15.8502 14.0083 15.8954 14.1323C15.9443 14.2665 15.9873 14.3852 16.0222 14.5004C16.1027 14.7662 16.0837 14.8463 16.088 14.8327L17.517 15.2888ZM19.9081 14.8439C19.9127 14.858 19.8932 14.777 19.9748 14.5075C20.01 14.3909 20.0536 14.2708 20.1029 14.1354C20.1486 14.0103 20.2042 13.8587 20.2448 13.7178L18.8033 13.303C18.7801 13.3836 18.7445 13.4822 18.6937 13.6217C18.6466 13.7508 18.5884 13.9098 18.5391 14.0729C18.4514 14.3624 18.3309 14.8421 18.4811 15.3059L19.9081 14.8439Z"
      fill="#00111A"
    />
    <path
      d="M3 12C3 10.1591 4.49238 8.66667 6.33333 8.66667C6.99912 8.66667 7.78404 8.78333 8.43137 8.60988C9.00652 8.45576 9.45576 8.00652 9.60988 7.43136C9.78333 6.78404 9.66667 5.99912 9.66667 5.33333C9.66667 3.49238 11.1591 2 13 2"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const AltPaymentIcon = (props: IconProps) => (
  <Icon
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.002 13.5C16.002 14.3284 16.6735 15 17.502 15C18.3304 15 19.002 14.3284 19.002 13.5C19.002 12.6716 18.3304 12 17.502 12C16.6735 12 16.002 12.6716 16.002 13.5Z"
      stroke="#00111A"
      strokeWidth="1.5"
    />
    <path
      d="M2.00195 11C2.00195 7.22876 2.00195 5.34315 3.17353 4.17157C4.3451 3 6.23072 3 10.002 3H14.002C14.9319 3 15.3969 3 15.7784 3.10222C16.8137 3.37962 17.6223 4.18827 17.8997 5.22354C18.002 5.60504 18.002 6.07003 18.002 7M10.002 7H16.002C18.8304 7 20.2446 7 21.1233 7.87868C22.002 8.75736 22.002 10.1716 22.002 13V15C22.002 17.8284 22.002 19.2426 21.1233 20.1213C20.2446 21 18.8304 21 16.002 21H12.5005"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.75 17H2.25M9.75 17C9.75 17.7002 7.7557 19.0085 7.25 19.5M9.75 17C9.75 16.2998 7.7557 14.9915 7.25 14.5"
      stroke="#00111A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
